import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ResultInfo from './result-info';

import actions from '../actions';

const CLASS_NAME = 'slx-product-wizard-sheet';
const body = document.getElementsByTagName('body')[0];

export default createReactClass({

	propTypes: {
		item: PropTypes.object,
		isAuto: PropTypes.bool,
		languageCode: PropTypes.string,
		region: PropTypes.string,
		apiUrl: PropTypes.string
	},

	onContentClick() {
		this.close();
	},

	onInfoWrapClick(event) {
		event.stopPropagation();
	},

	close() {
		actions.closeSheet(this.props.isAuto);
	},

	render() {
		let className = CLASS_NAME;
		if (this.props.item) {
			className += ' active';
			body.classList.add('noscroll');
		} else {
			body.classList.remove('noscroll');
		}

		if (!this.props.item) {
			return <span />;
		}
		const price = (this.props.item.compositions && this.props.item.compositions[31]) || '';

		return (
			<div className={className} onClick={this.onContentClick}>
				<div className={`${CLASS_NAME}__info-wrap ${CLASS_NAME}__region-${this.props.region}`} onClick={this.onInfoWrapClick}>
					<div>
						<div className={`${CLASS_NAME}__head`} onClick={this.showSheet}>
							<div className={`${CLASS_NAME}__label`}>
								{this.props.item.number}
								<span className={`${CLASS_NAME}__label--price`}  dangerouslySetInnerHTML={{__html: price}}></span>
							</div>
						</div>
						<ResultInfo item={this.props.item} languageCode={this.props.languageCode} region={this.props.region} apiUrl={this.props.apiUrl}/>
						<button className={`${CLASS_NAME}__close`} onClick={this.close}/>
					</div>
				</div>
			</div>
		);
	}
});
